import EventBus from './Event';
import Modal from './Modal';
import { preqGetFields } from './api_client/api_prequalification';
import { presGetFields } from './api_client/api_prescreening';

class DashboardStartNav {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$prequalificationCard = this.$el.find('[data-prequalification]');
    this.$prequalificationActions = this.$prequalificationCard.find('[data-preq-actions]');
    this.$prequalificationSubmitted = this.$prequalificationCard.find('[data-preq-submitted]');
    this.$prequalificationLink = this.$prequalificationCard.find('a');
    this.$prescreeningCard = this.$el.find('[data-prescreening]');
    this.hasSubmittedPres = false;

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    EventBus.on('user:loaded', this.getUserPresFields.bind(this));
    EventBus.on('user:loaded', this.getUserPreqFields.bind(this));
    EventBus.on('prescreening:submitted', this.onPrescreeningSubmitted.bind(this));
  }

  async getUserPresFields() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    const pres_owner_user = window.grapp.user.auth.email;
    try {
      const userFieldsRes = await presGetFields(pres_owner_user);

      if (userFieldsRes.fields) {
        this.hasSubmittedPres = !!userFieldsRes.fields.pres_hasSubmitted;
        if (this.hasSubmittedPres) {
          this.$prequalificationLink.removeAttr('data-modal-trigger');
          this.$prequalificationLink.off('click');
          this.$prescreeningCard.hide();

          const $modalTrigger = $(document.body).find('[data-modal-trigger="prescreening"]');
          $modalTrigger.attr('data-modal-section', 'calendar');
        } else {
          this.$prescreeningCard.find('a').attr('data-modal-section', 'prescreening');

          this.$prequalificationLink.attr('data-modal-section', 'prescreening');
          this.$prequalificationLink.attr('data-modal-trigger', 'prescreening');
        }
      } else {
        this.$prescreeningCard.find('a').attr('data-modal-section', 'prescreening');

        this.$prequalificationLink.attr('data-modal-section', 'prescreening');
        this.$prequalificationLink.attr('data-modal-trigger', 'prescreening');
      }
    } catch(err) {
      console.error('preq get error: ', err);
    }
  }

  async getUserPreqFields() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    const preq_owner_user = window.grapp.user.auth.email;
    try {
      const userFieldsRes = await preqGetFields(preq_owner_user);

      if (userFieldsRes.fields) {
        if (userFieldsRes.fields.preq_legal_first_name) {
          const $preqCard = this.$prequalificationLink.closest('[data-prequalification]');
          const $preqTitle = $preqCard.find('.dshbd_nav_item_title');
          $preqTitle.text('Continue My Application');
        }

          if (userFieldsRes.fields.preq_hasSubmitted) {
            this.$prequalificationActions.hide();
            this.$prequalificationSubmitted.show();
          }
      }
    } catch(err) {
      console.error('preq get error: ', err);
    }
  }

  onPrescreeningSubmitted() {
    this.hasSubmittedPres = true;
    this.$prequalificationLink.removeAttr('data-modal-trigger');
    this.$prequalificationLink.off('click');
    this.$prescreeningCard.hide();

    const $modalTrigger = $(document.body).find('[data-modal-trigger="prescreening"]');
    $modalTrigger.attr('data-modal-section', 'calendar');
    Modal.showInnerSection('prescreening', 'calendar');
  }

  static init() {
    $('[data-js-component="dashboard-start-nav"]').each((i, el) => new DashboardStartNav(el));
  }
}

DashboardStartNav.init();
